import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-pagamento',
  templateUrl: './link-pagamento.component.html',
  styleUrls: ['./link-pagamento.component.css']
})
export class LinkPagamentoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
